import { render, staticRenderFns } from "./CreditGauge.vue?vue&type=template&id=0d22ad2e&scoped=true"
import script from "./CreditGauge.vue?vue&type=script&lang=js"
export * from "./CreditGauge.vue?vue&type=script&lang=js"
import style0 from "./CreditGauge.vue?vue&type=style&index=0&id=0d22ad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22ad2e",
  null
  
)

export default component.exports